import { configureConsole } from './lib/logger';

configureConsole();
